import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const EmptyPanel = styled.div`
    margin: auto;
    width: 100px;
`
export const SummaryStyle = styled.div`
    ${() => useFont('c32', { weight: '800' })};
    text-align: center;
    width: 650px;
    height: 50px;
    margin: auto;
`
export const DetailsStyle = styled.div`
    ${() => useFont('c16', { weight: '400' })};
    text-align: center;
    width: 650px;
    height: 30px;
    margin: auto;
`
export const ContainerStyle = styled.div`
    padding: 60px !important;
`
